(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apex-booking"] && !Shopify.designMode) return;
  try {
    
(function () {

      // Real backend (Cloudflare Worker) for slot-locking + automatic WhatsApp owner
      // notification. Empty string = backend not deployed yet, in which case everything
      // below automatically falls back to the old client-only behaviour (demo
      // availability data + manual WhatsApp click-to-send) so the live page keeps
      // working. Fill this in with the real workers.dev (or custom) URL once
      // `wrangler deploy` has run — see apex-backend/SETUP_GUIDE.md.
      var BACKEND_BASE_URL = 'https://apex-booking-backend.apexstudiouk.workers.dev';

      // Real payment: the deposit is added to your ACTUAL Shopify cart as one of these
      // two products, then the customer is sent to your normal Shopify checkout — so
      // whatever payment methods you already have enabled in Shopify Payments just
      // work, no separate payment processor needed. Fill in after creating "Booking
      // Deposit — Standard £50" and "Booking Deposit — OEM £150" products in Shopify
      // Admin (see apex-backend/SETUP_GUIDE.md for exact steps). Empty = falls back to
      // the manual WhatsApp flow, same as an unset BACKEND_BASE_URL.
      // Deposit ladder. Charged as N x the existing £50 deposit product rather than
      // new products, so the Shopify variant id never changes and the booking Worker
      // still recognises the order. OEM keeps its £150 floor.
      var DEPOSIT_UNIT = 50;
      var currentDepositUnits = 1;
      function depositUnitsFor(total, hasOEM){
        var units = total >= 1500 ? 4
                  : total >= 900  ? 3
                  : total >= 500  ? 2
                  : 1;
        if(hasOEM && units < 3){ units = 3; }
        return units;
      }

      var STANDARD_DEPOSIT_VARIANT_ID = '54398402134358';
      var OEM_DEPOSIT_VARIANT_ID = '54398403281238';

      function money(n){ return '£' + n.toFixed(2); }

      var cart = [];
      var els = document.querySelectorAll('[data-selectable]');
      var whenToPay = 'deposit'; // 'deposit' | 'full'
      var cartTotalPence = 0;
      var cartHasPOA = false;

      // Declared up here (not down in the date-picker section below) because render()
      // is called synchronously further down this same script, before that section
      // runs — var hoisting would otherwise leave RESTRICTED_LEAD_ITEMS as undefined
      // at that point and throw on the very first render().
      var RESTRICTED_LEAD_ITEMS = ['OEM Ambient', 'CarPlay & Android Auto', 'Reverse Camera'];
      var RESTRICTED_LEAD_BUSINESS_DAYS = 7;
      var lastCartNeedsLeadTime = false;
      var bookedIsoDatesCache = null;

      function setWhenToPay(mode){
        whenToPay = mode;
        var paymentMethodHeading = document.getElementById('payment-method-heading');
        var paymentMethodRow = document.getElementById('payment-method-row');
        var paymentSummary = document.getElementById('payment-summary');
        var confirmFine = document.getElementById('confirm-fine');
        var selectedBalanceToggle = paymentMethodRow.querySelector('.toggle.selected');

        if(mode === 'full'){
          paymentMethodHeading.style.display = 'none';
          paymentMethodRow.style.display = 'none';
          paymentSummary.textContent = 'Paid in full (online)';
          confirmFine.textContent = 'First name and phone number are required to book. The full amount is charged now, online — nothing left to pay on the day. Free cancellation up to 24h before — cancelling on the day forfeits the booking (see refund terms). POA items must be settled via deposit instead, since the final price isn’t fixed yet.';
        } else {
          paymentMethodHeading.style.display = '';
          paymentMethodRow.style.display = '';
          paymentSummary.textContent = selectedBalanceToggle ? selectedBalanceToggle.dataset.label : 'Cash';
          confirmFine.textContent = 'First name and phone number are required to book. The deposit shown above is charged now to confirm your booking, whether you wait on-site or drop off. Balance paid on the day. Free cancellation up to 24h before — cancelling on the day forfeits your deposit, and rescheduling means paying a new one. POA items confirmed after inspection.';
        }
        render();
      }

      var whenpayRow = document.getElementById('whenpay-row');
      var whenpayFullToggle = document.getElementById('whenpay-full-toggle');
      var whenpayPoaNote = document.getElementById('whenpay-poa-note');
      whenpayRow.querySelectorAll('.toggle').forEach(function(el){
        el.addEventListener('click', function(){
          if(el.dataset.when === 'full' && cartHasPOA){
            return; // disabled while a POA item is selected — see render()
          }
          whenpayRow.querySelectorAll('.toggle').forEach(function(t){ t.classList.remove('selected'); });
          el.classList.add('selected');
          setWhenToPay(el.dataset.when);
        });
      });

      function render(){
        var list = document.getElementById('cart-list');
        var totalEl = document.getElementById('cart-total');
        var emptyEl = document.getElementById('cart-empty');
        var durationRow = document.getElementById('duration-row');
        var durationEl = document.getElementById('duration-summary');


        list.innerHTML = '';
        var total = 0, hasPOA = false, totalHours = 0, hasUnknownDuration = false;
        cart.forEach(function(item){
          var row = document.createElement('div');
          row.className = 'summary-item';
          row.innerHTML = '<span>' + item.name + '</span><span>' + item.priceLabel + '</span>';
          list.appendChild(row);
          if(item.poa){ hasPOA = true; } else { total += item.price; }
          if(item.hoursPoa){ hasUnknownDuration = true; }
          else if(item.hours){ totalHours += item.hours; }
        });
        // Bundle discount — pick 2 services save 5%, pick 3 or more save 10%.
        // Applies to the services themselves only: travel, surcharges and add-ons
        // are excluded, exactly as the printed menu states.
        var NOT_A_SERVICE = ['Travel Fee', 'Sunday Surcharge', 'Late-Night Service Fee',
                             'Extra shooting stars', 'Custom logo in stars',
                             'Starlight in doors'];
        var serviceItems = cart.filter(function(c){ return NOT_A_SERVICE.indexOf(c.name) === -1; });
        var bundleRate = serviceItems.length >= 3 ? 0.10 : (serviceItems.length === 2 ? 0.05 : 0);
        var discountable = serviceItems.reduce(function(sum, c){ return sum + (c.poa ? 0 : c.price); }, 0);
        var bundleDiscount = Math.round(discountable * bundleRate * 100) / 100;
        if(bundleDiscount > 0){
          total -= bundleDiscount;
          var drow = document.createElement('div');
          drow.className = 'summary-item';
          drow.style.color = 'var(--green)';
          drow.innerHTML = '<span>Bundle discount — ' + Math.round(bundleRate * 100) +
                           '% off ' + serviceItems.length + ' services</span><span>−' + money(bundleDiscount) + '</span>';
          list.appendChild(drow);
        }

        totalEl.textContent = money(total) + (hasPOA ? ' + POA' : '');
        emptyEl.style.display = cart.length ? 'none' : 'block';
        cartTotalPence = Math.round(total * 100);
        cartHasPOA = hasPOA;

        // items that need ordering in (OEM, CarPlay/Android Auto, reverse camera)
        // push the earliest bookable date out by RESTRICTED_LEAD_BUSINESS_DAYS —
        // only rebuild the date grid when this actually flips, so normal cart
        // interactions don't keep resetting the customer's chosen date.
        var needsLeadTime = cart.some(function(item){ return RESTRICTED_LEAD_ITEMS.indexOf(item.name) > -1; });
        if(needsLeadTime !== lastCartNeedsLeadTime){
          lastCartNeedsLeadTime = needsLeadTime;
          buildDateGrid();
        }

        // "Pay in full" isn't offered while a POA (quote-on-inspection) item is
        // selected, since the final price isn't known yet — grey it out, and
        // bounce back to the deposit flow if one gets added after full was chosen.
        whenpayFullToggle.classList.toggle('disabled', hasPOA);
        whenpayPoaNote.style.display = hasPOA ? 'block' : 'none';
        if(hasPOA && whenToPay === 'full'){
          whenpayRow.querySelectorAll('.toggle').forEach(function(t){ t.classList.remove('selected'); });
          whenpayRow.querySelector('[data-when="deposit"]').classList.add('selected');
          setWhenToPay('deposit');
          return; // setWhenToPay() calls render() again with the reverted state
        }

        if(totalHours > 0 || hasUnknownDuration){
          durationRow.style.display = 'flex';
          var hrsText = totalHours > 0 ? (totalHours % 1 === 0 ? totalHours + ' hrs' : totalHours.toFixed(1) + ' hrs') : '';
          durationEl.textContent = hrsText + (hasUnknownDuration ? (hrsText ? ' + TBC' : 'Confirmed on inspection') : '');
        } else {
          durationRow.style.display = 'none';
        }

        // Deposit scales with the size of the job (see depositUnitsFor)
        var hasOEM = cart.some(function(item){ return item.name === 'OEM Ambient'; });
        currentDepositUnits = depositUnitsFor(total, hasOEM);
        var deposit = currentDepositUnits * DEPOSIT_UNIT;
        var depositLabel = document.getElementById('deposit-label');
        var depositAmount = document.getElementById('deposit-amount');
        if(whenToPay === 'full'){
          depositLabel.textContent = 'Total due now (paid in full)';
          depositAmount.textContent = money(total);
        } else {
          depositLabel.textContent = hasOEM
            ? 'Deposit due now (OEM minimum)'
            : (currentDepositUnits > 1 ? 'Deposit due now (scales with job size)' : 'Deposit due now (online)');
          depositAmount.textContent = money(deposit);
        }
      }

      els.forEach(function(el){
        el.addEventListener('click', function(){
          var group = el.dataset.group;
          var name = el.dataset.name;
          var wasSelected = el.classList.contains('selected');

          // only one selection allowed per section — clear any other pick in this group
          if(group){
            els.forEach(function(other){
              if(other !== el && other.dataset.group === group && other.classList.contains('selected')){
                other.classList.remove('selected');
                var oidx = cart.findIndex(function(c){ return c.name === other.dataset.name; });
                if(oidx > -1){ cart.splice(oidx, 1); }
              }
            });
          }

          if(wasSelected){
            var idx = cart.findIndex(function(c){ return c.name === name; });
            if(idx > -1){ cart.splice(idx, 1); }
            el.classList.remove('selected');
          } else {
            var price = parseFloat(el.dataset.price || '0');
            var poa = el.dataset.poa === 'true';
            var priceLabel = el.dataset.priceLabel || (poa ? 'POA' : money(price));
            var hours = parseFloat(el.dataset.hours || '0');
            var hoursPoa = el.dataset.hoursPoa === 'true';
            cart.push({ name: name, price: price, poa: poa, priceLabel: priceLabel, hours: hours, hoursPoa: hoursPoa });
            el.classList.add('selected');
          }
          render();
        });
      });

      // default: pre-select the best seller
      var defaultEl = document.querySelector('[data-name="2. The Signature"]');
      if(defaultEl){ defaultEl.click(); }
      render();

      // shooting stars: quantity picker instead of a single toggle
      var doorQty = document.getElementById('starlight-doors-qty');
      if(doorQty){
        doorQty.addEventListener('change', function(){
          var n = parseInt(doorQty.value, 10);
          if(n > 0){
            upsertCartItem({
              name: 'Starlight in doors',
              price: n * 99.99,
              poa: false,
              priceLabel: n + ' door' + (n > 1 ? 's' : '') + ' — ' + money(n * 99.99)
            });
          } else {
            removeCartItem('Starlight in doors');
          }
        });
      }

      var starQty = document.getElementById('shooting-star-qty');
      starQty.addEventListener('change', function(){
        var qty = parseInt(starQty.value, 10);
        if(qty > 0){
          upsertCartItem({
            name: 'Extra shooting stars',
            price: qty * 39.99,
            poa: false,
            priceLabel: 'x' + qty + ' — ' + money(qty * 39.99)
          });
        } else {
          removeCartItem('Extra shooting stars');
        }
      });

      // toggle rows (fitting option, payment method) — each row is its own single-select group.
      // "whenpay-row" has its own dedicated handler above (it needs the POA-disable check), so skip it here.
      document.querySelectorAll('.toggle-row').forEach(function(row){
        if(row.id === 'whenpay-row' || row.id === 'location-row'){ return; }
        row.querySelectorAll('.toggle').forEach(function(el){
          el.addEventListener('click', function(){
            row.querySelectorAll('.toggle').forEach(function(t){ t.classList.remove('selected'); });
            el.classList.add('selected');

            var targetId = el.dataset.summaryTarget;
            var label = el.dataset.label;
            if(targetId && label){
              var targetEl = document.getElementById(targetId);
              if(targetEl){ targetEl.textContent = label; }
            }
            // £50 deposit is required either way (wait on-site or drop off) — paid straight away online
          });
        });
      });

      // ---- Date picker: real calendar, any month, next-day booking closes at 5pm ----
      var DOW = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
      var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      var MONTHS_FULL = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      var dateGrid = document.getElementById('date-grid');
      var dateNote = document.getElementById('date-note');
      var dateSummary = document.getElementById('date-summary');
      var calMonthLabel = document.getElementById('cal-month-label');
      var calPrevBtn = document.getElementById('cal-prev-btn');
      var calNextBtn = document.getElementById('cal-next-btn');
      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate()); // midnight today, for date-only comparisons
      var nextDayCutoffPassed = now.getHours() >= 17; // 5pm
      var selectedDateISO = '';

      // which month the calendar is currently showing — customers can flip forward/back
      // to any month to pick a date, not just the next few weeks
      var viewYear = now.getFullYear();
      var viewMonth = now.getMonth(); // 0-indexed
      var monthRollForward = 0;   // how many times we auto-advanced past an empty month

      // Studio's fixed weekly days off — 0=Sun, 1=Mon, 2=Tue, 3=Wed, 4=Thu, 5=Fri, 6=Sat.
      // Currently closed every Monday, Wednesday and Friday.
      var WEEKLY_CLOSED_DAYS = [1, 3, 5];

      // demo data — used only if the real backend isn't deployed yet / unreachable
      var DEMO_FULLY_BOOKED_OFFSETS = [3, 5];

      // RESTRICTED_LEAD_ITEMS / RESTRICTED_LEAD_BUSINESS_DAYS / lastCartNeedsLeadTime /
      // bookedIsoDatesCache are declared up near `cart` above (render() runs before this
      // point on page load, so they need to already have real values by then).
      // The backend only returns real confirmed/blocked dates up to 60 days out (its own
      // cap) — the calendar itself lets you browse any future month, but months beyond
      // that live-data window just show as normally open (no real bookings can exist that
      // far out yet anyway).
      var AVAILABILITY_FETCH_DAYS = 60;

      function localISO(d){
        return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      }
      function isoOffset(offsetDays){
        var d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + offsetDays);
        return localISO(d);
      }

      function addBusinessDays(fromDate, businessDays){
        var d = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
        var added = 0;
        while(added < businessDays){
          d.setDate(d.getDate() + 1);
          var dow = d.getDay();
          if(dow !== 0 && dow !== 6){ added++; } // skip Sat/Sun — supplier business days, not studio opening days
        }
        return d;
      }

      function fetchRealBookedDates(){
        if(!BACKEND_BASE_URL){ return Promise.resolve(null); }
        var controller = new AbortController();
        var timeout = setTimeout(function(){ controller.abort(); }, 5000);
        return fetch(BACKEND_BASE_URL + '/api/availability?days=' + AVAILABILITY_FETCH_DAYS, { signal: controller.signal })
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(data){ return data ? { booked: data.bookedDates, open: data.openDates || [] } : null; })
          .catch(function(){ return null; }) // network error / timeout — fall back to demo data
          .finally(function(){ clearTimeout(timeout); });
      }

      function buildDateGrid(){
        var bookedIsoDates = bookedIsoDatesCache ? bookedIsoDatesCache.booked : null;
        var openIsoDates = bookedIsoDatesCache ? bookedIsoDatesCache.open : [];
        var useReal = Array.isArray(bookedIsoDates);
        var cutoffDate = lastCartNeedsLeadTime ? addBusinessDays(now, RESTRICTED_LEAD_BUSINESS_DAYS) : null;

        calMonthLabel.textContent = MONTHS_FULL[viewMonth] + ' ' + viewYear;
        calPrevBtn.disabled = (viewYear === now.getFullYear() && viewMonth === now.getMonth());

        dateGrid.innerHTML = '';

        var firstOfMonth = new Date(viewYear, viewMonth, 1);
        var daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
        var startDow = firstOfMonth.getDay();

        for(var b = 0; b < startDow; b++){
          var blank = document.createElement('div');
          blank.className = 'date-chip blank';
          dateGrid.appendChild(blank);
        }

        for(var day = 1; day <= daysInMonth; day++){
          var d = new Date(viewYear, viewMonth, day);
          var iso = localISO(d);
          var dayDiff = Math.round((d.getTime() - today.getTime()) / 86400000);
          var chip = document.createElement('div');
          chip.className = 'date-chip';
          chip.dataset.iso = iso;
          chip.dataset.dow = d.getDay();
          chip.dataset.label = DOW[d.getDay()] + ', ' + d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();

          var isPast = dayDiff < 0;
          // rule: once it's past 5pm today, tomorrow (dayDiff === 1) is no longer bookable
          var isBlockedNextDay = (dayDiff === 1 && nextDayCutoffPassed);
          // studio's fixed days off, e.g. Mon/Wed/Fri — unless the owner has explicitly
          // opened this specific date from the admin calendar (an "open override").
          var isOpenOverride = useReal && openIsoDates.indexOf(iso) > -1;
          var isClosedWeekday = WEEKLY_CLOSED_DAYS.indexOf(d.getDay()) > -1 && !isOpenOverride;
          var isFullyBooked = useReal ? bookedIsoDates.indexOf(iso) > -1 : DEMO_FULLY_BOOKED_OFFSETS.indexOf(dayDiff) > -1;
          var isTooSoonToOrder = cutoffDate ? (d.getTime() < cutoffDate.getTime()) : false;
          var isUnavailable = isPast || isBlockedNextDay || isClosedWeekday || isFullyBooked || isTooSoonToOrder;

          var isSunday = d.getDay() === 0;
          var statusText = isPast ? '' : (isTooSoonToOrder ? 'Order lead' : (isBlockedNextDay ? 'Closed' : (isClosedWeekday ? 'Booked' : (isFullyBooked ? 'Taken' : (isSunday ? '+£70' : 'Open')))));
          if(isUnavailable){ chip.classList.add('disabled'); } else { chip.classList.add('available'); }
          if(isSunday){ chip.classList.add('sunday'); }
          if(iso === selectedDateISO){ chip.classList.add('selected'); }

          chip.innerHTML = '<div class="dnum">' + d.getDate() + '</div><div class="dstatus">' + statusText + '</div>';
          dateGrid.appendChild(chip);

          if(!isUnavailable){
            chip.addEventListener('click', function(){
              document.querySelectorAll('.date-chip').forEach(function(c){ c.classList.remove('selected'); });
              this.classList.add('selected');
              dateSummary.textContent = this.dataset.label;
              selectedDateISO = this.dataset.iso;
              applySundaySurcharge(this);
            });
          }
        }

        // If the month being shown has nothing bookable left (typically the last days
        // of a month), roll forward automatically so the calendar never opens on a dead
        // month. Guarded so it can only ever step forward a couple of times.
        if(!selectedDateISO && !dateGrid.querySelector('.date-chip.available') && monthRollForward < 2){
          monthRollForward++;
          viewMonth++;
          if(viewMonth > 11){ viewMonth = 0; viewYear++; }
          buildDateGrid();
          return;
        }

        // auto-select the first bookable date on initial load only — never yank the
        // customer's chosen date out from under them just because the cart or month changed
        if(!selectedDateISO){
          var firstBookable = dateGrid.querySelector('.date-chip.available');
          if(firstBookable){
            firstBookable.classList.add('selected');
            dateSummary.textContent = firstBookable.dataset.label;
            selectedDateISO = firstBookable.dataset.iso;
            applySundaySurcharge(firstBookable);
          }
        }
        dateNote.textContent = (nextDayCutoffPassed
          ? "It's past 5pm — next-day booking is closed for today. Green dates are open, grey ones are closed or already taken."
          : 'Green dates are open to book. Grey means fully booked or closed (next-day booking closes at 5pm).')
          + ' Use the arrows above to browse other months.'
          + ' Sundays carry a £70 surcharge.'
          + (cutoffDate ? (' A selected item needs to be ordered in — earliest available date is ' + DOW[cutoffDate.getDay()] + ', ' + cutoffDate.getDate() + ' ' + MONTHS[cutoffDate.getMonth()] + '.') : '')
          + (useReal ? '' : ' (Live availability temporarily unavailable — showing estimated dates.)');
      }

      calPrevBtn.addEventListener('click', function(){
        if(calPrevBtn.disabled) return;
        viewMonth--;
        if(viewMonth < 0){ viewMonth = 11; viewYear--; }
        buildDateGrid();
      });
      calNextBtn.addEventListener('click', function(){
        viewMonth++;
        if(viewMonth > 11){ viewMonth = 0; viewYear++; }
        buildDateGrid();
      });

      // Sunday bookings carry a £70 surcharge on top of everything else
      var SUNDAY_FEE = 70;
      function applySundaySurcharge(chip){
        if(parseInt(chip.dataset.dow, 10) === 0){
          upsertCartItem({ name: 'Sunday Surcharge', price: SUNDAY_FEE, poa: false, priceLabel: money(SUNDAY_FEE) });
        } else {
          removeCartItem('Sunday Surcharge');
        }
      }

      fetchRealBookedDates().then(function(availability){
        bookedIsoDatesCache = availability;
        buildDateGrid();
      });

      // require first name + phone before confirming
      var confirmBtn = document.getElementById('confirm-btn');
      var firstNameInput = document.getElementById('first-name-input');
      var phoneInput = document.getElementById('phone-input');
      confirmBtn.addEventListener('click', function(){
        var missing = [];
        if(!firstNameInput.value.trim()){ missing.push(firstNameInput); }
        if(!phoneInput.value.trim()){ missing.push(phoneInput); }
        if(missing.length){
          missing.forEach(function(inp){ inp.style.borderColor = '#ff6b6b'; });
          missing[0].focus();
          return;
        }
        firstNameInput.style.borderColor = '';
        phoneInput.style.borderColor = '';

        if(!selectedDateISO){
          alert('Please pick an installation date on the calendar first.');
          var calEl = document.getElementById('date-grid');
          if(calEl){ calEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          return;
        }

        var itemLines = cart.map(function(c){ return '- ' + c.name + ': ' + c.priceLabel; }).join('\n');
        var hasOEM = cart.some(function(c){ return c.name === 'OEM Ambient'; });
        var depositVariantId = hasOEM ? OEM_DEPOSIT_VARIANT_ID : STANDARD_DEPOSIT_VARIANT_ID;
        var bookingFields = {
          firstName: firstNameInput.value.trim(),
          phone: phoneInput.value.trim(),
          vehicle: vehicleSummary.textContent || '—',
          date: selectedDateISO,
          time: timeSummary.textContent || '—',
          option: document.getElementById('option-summary').textContent,
          location: document.getElementById('location-summary').textContent,
          paymentMethod: document.getElementById('payment-summary').textContent,
          totalLabel: document.getElementById('cart-total').textContent,
          notes: document.getElementById('notes-input').value.trim(),
        };

        function sendViaWhatsAppFallback(){
          // used when the deposit products/backend aren't set up yet, the date was
          // just taken, or adding to cart fails for any reason — customer hits send,
          // message lands straight in Apex Studio's WhatsApp inbox
          var OWNER_WHATSAPP = '447757159068';
          var msg = 'New booking request via website:\n' +
            'Name: ' + bookingFields.firstName + '\n' +
            'Phone: ' + bookingFields.phone + '\n' +
            'Vehicle: ' + bookingFields.vehicle + '\n' +
            'Date: ' + (dateSummary.textContent || '—') + '\n' +
            'Time: ' + bookingFields.time + '\n' +
            'Option: ' + bookingFields.option + '\n' +
            'Location: ' + bookingFields.location + '\n' +
            'Payment: ' + bookingFields.paymentMethod + '\n' +
            (itemLines ? ('Items:\n' + itemLines + '\n') : '') +
            'Total: ' + bookingFields.totalLabel + '\n' +
            'Deposit due now: ' + document.getElementById('deposit-amount').textContent + '\n' +
            'Notes: ' + (bookingFields.notes || 'none');
          window.open('https://wa.me/' + OWNER_WHATSAPP + '?text=' + encodeURIComponent(msg), '_blank');
        }

        if(whenToPay === 'full'){
          if(!BACKEND_BASE_URL){
            // full-payment needs the backend to create a Shopify Draft Order for the
            // exact computed total — if it's not configured yet, fall back to WhatsApp
            sendViaWhatsAppFallback();
            return;
          }

          confirmBtn.disabled = true;
          confirmBtn.textContent = 'Checking date…';

          fetchRealBookedDates().then(function(availability){
            var takenDates = availability ? availability.booked : null;
            if(Array.isArray(takenDates) && takenDates.indexOf(selectedDateISO) > -1){
              confirmBtn.disabled = false;
              confirmBtn.textContent = 'Confirm Booking';
              alert('That date was just taken by someone else — please pick another date.');
              return;
            }

            confirmBtn.textContent = 'Creating payment link…';

            var controller = new AbortController();
            var timeout = setTimeout(function(){ controller.abort(); }, 8000);

            fetch(BACKEND_BASE_URL + '/api/create-full-payment-order', {
              method: 'POST',
              headers: { 'content-type': 'application/json' },
              signal: controller.signal,
              body: JSON.stringify({
                name: bookingFields.firstName,
                phone: bookingFields.phone,
                vehicle: bookingFields.vehicle,
                date: bookingFields.date,
                time: bookingFields.time,
                option: bookingFields.option,
                location: bookingFields.location,
                itemsText: itemLines || 'none',
                totalLabel: bookingFields.totalLabel,
                notes: bookingFields.notes || 'none',
                totalPence: cartTotalPence,
              }),
            })
              .then(function(r){ if(!r.ok){ throw new Error('create-full-payment-order-failed'); } return r.json(); })
              .then(function(data){
                if(!data.invoiceUrl){ throw new Error('no-invoice-url'); }
                // real Shopify-hosted invoice — customer pays the FULL amount here,
                // through whatever payment methods are already enabled in Shopify Payments
                window.location.href = data.invoiceUrl;
              })
              .catch(function(){
                confirmBtn.disabled = false;
                confirmBtn.textContent = 'Confirm Booking';
                sendViaWhatsAppFallback();
              })
              .finally(function(){ clearTimeout(timeout); });
          });
          return;
        }

        if(!depositVariantId){
          sendViaWhatsAppFallback();
          return;
        }

        confirmBtn.disabled = true;
        confirmBtn.textContent = 'Checking date…';

        // last-second re-check that this date hasn't just been taken by someone else,
        // then hand off to Shopify's real cart + checkout for the actual payment
        (BACKEND_BASE_URL ? fetchRealBookedDates() : Promise.resolve(null)).then(function(bookedDates){
          if(Array.isArray(bookedDates) && bookedDates.indexOf(selectedDateISO) > -1){
            confirmBtn.disabled = false;
            confirmBtn.textContent = 'Confirm Booking';
            alert('That date was just taken by someone else — please pick another date.');
            return;
          }

          confirmBtn.textContent = 'Processing…';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: depositVariantId,
                quantity: (depositVariantId === OEM_DEPOSIT_VARIANT_ID ? 1 : currentDepositUnits),
                properties: {
                  'Name': bookingFields.firstName,
                  'Phone': bookingFields.phone,
                  'Vehicle': bookingFields.vehicle,
                  'Date': bookingFields.date,
                  'Time': bookingFields.time,
                  'Option': bookingFields.option,
                  'Location': bookingFields.location,
                  'Payment Method (balance)': bookingFields.paymentMethod,
                  'Items': itemLines || 'none',
                  'Total': bookingFields.totalLabel,
                  'Notes': bookingFields.notes || 'none',
                },
              }],
            }),
          })
            .then(function(r){ if(!r.ok){ throw new Error('cart-add-failed'); } return r.json(); })
            .then(function(){
              // real Shopify checkout — customer actually pays the deposit here,
              // through whatever payment methods are already enabled in Shopify Payments
              window.location.href = '/checkout';
            })
            .catch(function(){
              confirmBtn.disabled = false;
              confirmBtn.textContent = 'Confirm Booking';
              sendViaWhatsAppFallback();
            });
        });
      });
      [firstNameInput, phoneInput].forEach(function(inp){
        inp.addEventListener('input', function(){ inp.style.borderColor = ''; });
      });


      // time slots — 4pm onward adds a £100 late-night surcharge
      var LATE_FEE = 100;
      var timeSummary = document.getElementById('time-summary');
      document.querySelectorAll('.slot:not(.disabled)').forEach(function(el){
        el.addEventListener('click', function(){
          document.querySelectorAll('.slot').forEach(function(s){ s.classList.remove('selected'); });
          el.classList.add('selected');
          timeSummary.textContent = el.dataset.time;

          if(el.dataset.late === 'true'){
            upsertCartItem({ name: 'Late-Night Service Fee', price: LATE_FEE, poa: false, priceLabel: money(LATE_FEE) });
          } else {
            removeCartItem('Late-Night Service Fee');
          }
        });
      });

      // ---- Vehicle: Make -> Model dropdowns (curated UK/EU lineup) + Year dropdown ----
      // This is a hand-curated list of common current/recent makes & models sold in the UK
      // rather than a live lookup — the free US NHTSA vehicle API was tested and rejected
      // because it's missing or badly incomplete for UK-market brands (e.g. zero results for
      // Vauxhall, only 4 decades-old models for Peugeot), which would make it worse than no
      // dropdown at all. "Other / not listed" always falls back to a free-text field so no
      // customer's car is ever unbookable.
      var MAKE_MODELS = {
        "Audi": ["A1","A3","A4","A5","A6","A7","A8","Q2","Q3","Q4 e-tron","Q5","Q7","Q8","e-tron","TT","R8"],
        "BMW": ["1 Series","2 Series","3 Series","4 Series","5 Series","6 Series","7 Series","8 Series","X1","X2","X3","X4","X5","X6","X7","Z4","i3","i4","i7","iX","M2","M3","M4","M5"],
        "Mercedes-Benz": ["A-Class","B-Class","C-Class","E-Class","S-Class","CLA","CLS","GLA","GLB","GLC","GLE","GLS","G-Class","EQA","EQB","EQC","EQE","EQS","SL","AMG GT"],
        "Volkswagen": ["Polo","Golf","Golf GTI","Passat","Arteon","T-Cross","T-Roc","Tiguan","Touareg","ID.3","ID.4","ID.5","ID.7","Up!","Caddy"],
        "Ford": ["Fiesta","Focus","Puma","Kuga","Mondeo","EcoSport","Edge","Ranger","Mustang","Mustang Mach-E","Galaxy","S-Max","Transit","Transit Custom"],
        "Vauxhall": ["Corsa","Astra","Insignia","Mokka","Crossland","Grandland","Combo","Vivaro","Viva","Adam","Zafira"],
        "Toyota": ["Aygo X","Yaris","Yaris Cross","Corolla","C-HR","RAV4","Camry","Prius","Land Cruiser","Hilux","Supra","GR86","bZ4X"],
        "Honda": ["Jazz","Civic","CR-V","HR-V","e","ZR-V"],
        "Nissan": ["Micra","Note","Juke","Qashqai","X-Trail","Leaf","Ariya","Navara"],
        "Kia": ["Picanto","Rio","Ceed","XCeed","Stonic","Sportage","Sorento","Niro","EV6","EV9","Soul"],
        "Hyundai": ["i10","i20","i30","Bayon","Kona","Tucson","Santa Fe","Ioniq 5","Ioniq 6"],
        "Peugeot": ["108","208","2008","308","3008","5008","508","Rifter","Partner"],
        "Citroën": ["C1","C3","C3 Aircross","C4","C4 X","C5 Aircross","C5 X","Berlingo","ë-C4"],
        "Renault": ["Clio","Captur","Megane","Megane E-Tech","Kadjar","Arkana","Austral","Scenic","Zoe","Trafic"],
        "SEAT": ["Ibiza","Leon","Arona","Ateca","Tarraco"],
        "Škoda": ["Fabia","Scala","Octavia","Kamiq","Karoq","Kodiaq","Superb","Enyaq"],
        "Volvo": ["XC40","XC60","XC90","S60","S90","V60","V90","C40 Recharge","EX30","EX90"],
        "Land Rover": ["Defender","Discovery","Discovery Sport","Range Rover","Range Rover Sport","Range Rover Evoque","Range Rover Velar"],
        "Jaguar": ["XE","XF","F-Pace","E-Pace","I-Pace","F-Type"],
        "MINI": ["Hatch","Convertible","Clubman","Countryman","Electric"],
        "Fiat": ["500","500e","500X","Panda","Tipo","Doblo"],
        "Mazda": ["2","3","6","CX-3","CX-30","CX-5","CX-60","MX-5"],
        "Suzuki": ["Swift","Ignis","Vitara","S-Cross","Jimny"],
        "Tesla": ["Model 3","Model S","Model X","Model Y"],
        "Porsche": ["911","718 Cayman","718 Boxster","Panamera","Macan","Cayenne","Taycan"],
        "Lexus": ["CT","IS","ES","LS","UX","NX","RX","LX","RC","LC"],
        "Mitsubishi": ["Mirage","ASX","Eclipse Cross","Outlander","L200"],
        "Dacia": ["Sandero","Duster","Jogger","Spring"],
        "Jeep": ["Renegade","Compass","Cherokee","Grand Cherokee","Wrangler","Avenger"],
        "Alfa Romeo": ["Giulia","Stelvio","Tonale"],
        "DS": ["DS 3","DS 4","DS 7","DS 9"],
        "Smart": ["EQ fortwo","EQ forfour","#1","#3"],
        "Subaru": ["Impreza","XV","Forester","Outback","BRZ"],
        "SsangYong": ["Tivoli","Korando","Rexton","Musso"],
        "MG": ["MG3","MG4 EV","MG5 EV","ZS","HS","Cyberster"],
        "Abarth": ["500","595","695"]
      };
      var OTHER_VALUE = '__other';

      var makeSelect = document.getElementById('make-select');
      var makeOtherInput = document.getElementById('make-other-input');
      var modelSelect = document.getElementById('model-select');
      var modelOtherInput = document.getElementById('model-other-input');
      var yearSelect = document.getElementById('year-select');
      var vehicleSummary = document.getElementById('vehicle-summary');

      Object.keys(MAKE_MODELS).sort().forEach(function(make){
        var opt = document.createElement('option');
        opt.value = make; opt.textContent = make;
        makeSelect.appendChild(opt);
      });
      var otherMakeOpt = document.createElement('option');
      otherMakeOpt.value = OTHER_VALUE; otherMakeOpt.textContent = 'Other / not listed';
      makeSelect.appendChild(otherMakeOpt);

      var thisYear = new Date().getFullYear();
      for(var y = thisYear + 1; y >= 1990; y--){
        var yOpt = document.createElement('option');
        yOpt.value = String(y); yOpt.textContent = String(y);
        yearSelect.appendChild(yOpt);
      }

      function currentMakeValue(){
        return makeSelect.value === OTHER_VALUE ? makeOtherInput.value.trim() : makeSelect.value;
      }
      function currentModelValue(){
        return modelSelect.value === OTHER_VALUE ? modelOtherInput.value.trim() : modelSelect.value;
      }
      function updateVehicleSummary(){
        var year = yearSelect.value;
        vehicleSummary.textContent = (currentMakeValue() + ' ' + currentModelValue() + (year ? ' (' + year + ')' : '')).trim() || '—';
      }

      makeSelect.addEventListener('change', function(){
        var make = makeSelect.value;
        makeOtherInput.style.display = (make === OTHER_VALUE) ? 'block' : 'none';

        modelSelect.innerHTML = '';
        modelOtherInput.style.display = 'none';
        modelOtherInput.value = '';

        if(make && make !== OTHER_VALUE && MAKE_MODELS[make]){
          modelSelect.disabled = false;
          var placeholder = document.createElement('option');
          placeholder.value = ''; placeholder.textContent = 'Select model…';
          modelSelect.appendChild(placeholder);
          MAKE_MODELS[make].forEach(function(model){
            var mOpt = document.createElement('option');
            mOpt.value = model; mOpt.textContent = model;
            modelSelect.appendChild(mOpt);
          });
          var mOther = document.createElement('option');
          mOther.value = OTHER_VALUE; mOther.textContent = 'Other / not listed';
          modelSelect.appendChild(mOther);
        } else {
          // "Other" make, or nothing selected yet — model must be typed manually
          modelSelect.disabled = true;
          var soloOpt = document.createElement('option');
          soloOpt.value = ''; soloOpt.textContent = make === OTHER_VALUE ? 'Type model below' : 'Select make first…';
          modelSelect.appendChild(soloOpt);
          if(make === OTHER_VALUE){ modelOtherInput.style.display = 'block'; }
        }
        updateVehicleSummary();
      });

      modelSelect.addEventListener('change', function(){
        modelOtherInput.style.display = (modelSelect.value === OTHER_VALUE) ? 'block' : 'none';
        updateVehicleSummary();
      });

      [makeOtherInput, modelOtherInput].forEach(function(input){
        input.addEventListener('input', updateVehicleSummary);
      });
      yearSelect.addEventListener('change', updateVehicleSummary);

      // ---- Mobile outcall travel fee: base postcode -> customer postcode ----
      var BASE_POSTCODE = 'EN3 7NH'; // 84 Bilton Way, Enfield
      var RATE_PER_MILE = 0.90;
      var MIN_TRAVEL_FEE = 60;

      function upsertCartItem(item){
        var idx = cart.findIndex(function(c){ return c.name === item.name; });
        if(idx > -1){ cart[idx] = item; } else { cart.push(item); }
        render();
      }
      function removeCartItem(name){
        var idx = cart.findIndex(function(c){ return c.name === name; });
        if(idx > -1){ cart.splice(idx, 1); render(); }
      }

      function haversineMiles(lat1, lon1, lat2, lon2){
        var R = 3958.8; // Earth radius in miles
        var dLat = (lat2 - lat1) * Math.PI / 180;
        var dLon = (lon2 - lon1) * Math.PI / 180;
        var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(lat1 * Math.PI/180) * Math.cos(lat2 * Math.PI/180) *
                Math.sin(dLon/2) * Math.sin(dLon/2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c; // straight-line ("as the crow flies") — used only as a fallback below
      }

      // Real one-way road-driving distance via OSRM's free public routing API (no key required).
      // Straight-line distance badly underestimates indirect/coastal routes, so this is the
      // primary source; if the service is unreachable we fall back to straight-line x1.4 (a
      // rough road-distance buffer) so the calculator still returns a usable number.
      var ROAD_DISTANCE_FALLBACK_BUFFER = 1.4;
      function drivingMilesOneWay(lat1, lon1, lat2, lon2){
        var url = 'https://router.project-osrm.org/route/v1/driving/' + lon1 + ',' + lat1 + ';' + lon2 + ',' + lat2 + '?overview=false';
        return fetch(url)
          .then(function(r){ return r.json(); })
          .then(function(data){
            if(data.code !== 'Ok' || !data.routes || !data.routes[0]) throw new Error('no route found');
            return data.routes[0].distance / 1609.344; // metres -> miles, real one-way driving distance
          });
      }

      function lookupPostcode(pc){
        return fetch('https://api.postcodes.io/postcodes/' + encodeURIComponent(pc))
          .then(function(r){ return r.json(); });
      }

      var locationRow = document.getElementById('location-row');
      var travelBlock = document.getElementById('travel-block');
      var travelResult = document.getElementById('travel-result');
      var locationSummary = document.getElementById('location-summary');
      var postcodeInput = document.getElementById('postcode-input');
      var calcBtn = document.getElementById('calc-travel-btn');

      // Location is its own toggle-row (Studio vs mobile outcall) with a dedicated handler
      // (like whenpay-row) since picking "mobile" also needs to reveal the postcode block —
      // the generic toggle-row loop further down skips both of these rows for that reason.
      locationRow.querySelectorAll('.toggle').forEach(function(el){
        el.addEventListener('click', function(){
          locationRow.querySelectorAll('.toggle').forEach(function(t){ t.classList.remove('selected'); });
          el.classList.add('selected');

          if(el.dataset.loc === 'mobile'){
            travelBlock.style.display = 'block';
            locationSummary.textContent = 'Mobile outcall';
          } else {
            travelBlock.style.display = 'none';
            locationSummary.textContent = '84 Bilton Way, Enfield';
            removeCartItem('Travel Fee');
            travelResult.textContent = 'Round-trip driving distance from our Enfield base (EN3 7NH). £0.90/mile, £60 minimum.';
            travelResult.style.color = 'var(--text-dim)';
          }
        });
      });

      calcBtn.addEventListener('click', function(){
        var postcode = postcodeInput.value.trim();
        if(!postcode){
          travelResult.textContent = 'Enter your postcode first.';
          travelResult.style.color = '#ff6b6b';
          return;
        }
        travelResult.textContent = 'Calculating distance from Enfield…';
        travelResult.style.color = 'var(--text-dim)';

        Promise.all([lookupPostcode(BASE_POSTCODE), lookupPostcode(postcode)])
          .then(function(results){
            var base = results[0], dest = results[1];
            if(base.status !== 200 || dest.status !== 200 || !dest.result){
              travelResult.textContent = "Couldn't find that postcode — check and try again.";
              travelResult.style.color = '#ff6b6b';
              removeCartItem('Travel Fee');
              return;
            }
            var b = base.result, d = dest.result;
            var straightLineMiles = haversineMiles(b.latitude, b.longitude, d.latitude, d.longitude);
            var usedFallback = false;

            drivingMilesOneWay(b.latitude, b.longitude, d.latitude, d.longitude)
              .catch(function(){
                usedFallback = true;
                return straightLineMiles * ROAD_DISTANCE_FALLBACK_BUFFER;
              })
              .then(function(oneWayMiles){
                var roundTripMiles = oneWayMiles * 2;
                var rawFee = roundTripMiles * RATE_PER_MILE;
                var fee = Math.max(MIN_TRAVEL_FEE, rawFee);
                var minApplied = rawFee < MIN_TRAVEL_FEE;

                travelResult.innerHTML = '≈ ' + oneWayMiles.toFixed(1) + ' mi each way (' + roundTripMiles.toFixed(1) + ' mi round trip) from Enfield (EN3 7NH)' +
                  (usedFallback ? ' — estimated, live route service unavailable' : '') +
                  ' · Travel fee: <strong style="color:var(--cyan);">' + money(fee) + '</strong>' +
                  (minApplied ? ' — £60 minimum applied' : ' (' + roundTripMiles.toFixed(1) + ' mi × £0.90)');
                travelResult.style.color = 'var(--text)';

                upsertCartItem({ name: 'Travel Fee', price: fee, poa: false, priceLabel: money(fee) });
              });
          })
          .catch(function(){
            travelResult.textContent = "Couldn't reach postcode lookup — check your connection and try again.";
            travelResult.style.color = '#ff6b6b';
          });
      });
    
})();

/* ===== mobile decompress enhancements (no booking logic touched) ===== */
(function () {
  var root = document.querySelector('.apex-fullbook');
  if (!root || root.dataset.mbInit) return;
  root.dataset.mbInit = '1';
  var mq = window.matchMedia('(max-width: 760px)');

  /* "Details" toggle on package cards (visible only on mobile via CSS) */
  root.querySelectorAll('.tier').forEach(function (t) {
    if (!t.querySelector('.tier-desc')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'apx-mb-more';
    btn.textContent = 'Details ▾';
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      var open = t.classList.toggle('m-open');
      btn.textContent = open ? 'Hide details ▴' : 'Details ▾';
    });
    var desc = t.querySelector('.tier-desc');
    desc.parentNode.insertBefore(btn, desc);
  });

  /* fixed bottom bar mirroring the live summary */
  var bar = document.createElement('div');
  bar.className = 'apx-mbar';
  bar.innerHTML = '<div class="t"><b id="apxMbTotal">£0.00</b><span>Deposit now <i id="apxMbDep">£50.00</i> · tap to review</span></div>' +
                  '<button type="button" id="apxMbGo">Confirm</button>';
  document.body.appendChild(bar);

  var totalSrc = document.getElementById('cart-total');
  var depSrc = document.getElementById('deposit-amount');
  var confirmBtn = document.getElementById('confirm-btn');

  function sync() {
    if (totalSrc) document.getElementById('apxMbTotal').textContent = totalSrc.textContent;
    if (depSrc) document.getElementById('apxMbDep').textContent = depSrc.textContent;
  }
  sync();
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(sync);
    if (totalSrc) mo.observe(totalSrc, { childList: true, characterData: true, subtree: true });
    if (depSrc) mo.observe(depSrc, { childList: true, characterData: true, subtree: true });
  }

  document.getElementById('apxMbGo').addEventListener('click', function () {
    if (confirmBtn) confirmBtn.click();
  });
  bar.querySelector('.t').addEventListener('click', function () {
    var s = document.querySelector('.summary-total');
    if (s) s.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* hide the bar when the real Confirm button is on screen */
  if (confirmBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { bar.classList.toggle('hidden-near', e.isIntersecting); });
    }, { threshold: 0.2 }).observe(confirmBtn);
  }

  function setOn() { bar.classList.toggle('on', mq.matches); }
  setOn();
  if (mq.addEventListener) mq.addEventListener('change', setOn);
  else if (mq.addListener) mq.addListener(setOn);
})();


/* ===== booking micro-animations: odometer total, deposit flip, fade-ups, busy state ===== */
(function () {
  var root = document.querySelector('.apex-fullbook');
  if (!root || root.dataset.animInit) return;
  root.dataset.animInit = '1';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* 1. odometer: animate #cart-total whenever the page logic rewrites it */
  var totalEl = document.getElementById('cart-total');
  function parseMoney(t) { var n = parseFloat(String(t).replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : n; }
  if (totalEl && 'MutationObserver' in window) {
    var shown = parseMoney(totalEl.textContent);
    var animating = false, raf = null, failsafe = null;
    function write(v) {
      animating = true;
      totalEl.textContent = '£' + v.toFixed(2);
      animating = false;
    }
    function stopAnim() {
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      if (failsafe) { clearTimeout(failsafe); failsafe = null; }
    }
    var mo = new MutationObserver(function () {
      if (animating) return;
      var target = parseMoney(totalEl.textContent);
      if (Math.abs(target - shown) < 0.005) { shown = target; return; }
      stopAnim();
      var from = shown, t0 = performance.now();
      /* failsafe: whatever happens, land on the real value */
      failsafe = setTimeout(function () { stopAnim(); shown = target; write(target); }, 680);
      raf = requestAnimationFrame(function tick(t) {
        var k = Math.min(1, (t - t0) / 520);
        var e = 1 - Math.pow(1 - k, 3);
        shown = from + (target - from) * e;
        write(shown);
        if (k < 1) { raf = requestAnimationFrame(tick); }
        else { shown = target; stopAnim(); }
      });
    });
    mo.observe(totalEl, { childList: true, characterData: true, subtree: true });
  }

  /* 4. deposit flip on change */
  var depEl = document.getElementById('deposit-amount');
  if (depEl && 'MutationObserver' in window) {
    var lastDep = depEl.textContent, depAnimating = false;
    new MutationObserver(function () {
      if (depAnimating) return;
      if (depEl.textContent === lastDep) return;
      lastDep = depEl.textContent;
      depAnimating = true;
      depEl.classList.remove('apx-flip'); void depEl.offsetWidth;
      depEl.classList.add('apx-flip');
      setTimeout(function () { depEl.classList.remove('apx-flip'); depAnimating = false; }, 550);
    }).observe(depEl, { childList: true, characterData: true, subtree: true });
  }

  /* 5. fade-ups on the big blocks */
  if ('IntersectionObserver' in window) {
    var targets = root.querySelectorAll('.tier, .flat-list, .notice-box, .card, .steps, .duo > *, .trio > *');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('apx-in'); io.unobserve(e.target); } });
    }, { threshold: 0.08 });
    targets.forEach(function (el) { el.classList.add('apx-anim'); io.observe(el); });
  }

  /* 6. busy spinner on Confirm while checkout/cart call runs */
  var cbtn = document.getElementById('confirm-btn');
  if (cbtn) {
    cbtn.addEventListener('click', function () {
      setTimeout(function () { if (cbtn.disabled) cbtn.classList.add('apx-busy'); }, 60);
    });
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        if (!cbtn.disabled) cbtn.classList.remove('apx-busy');
      }).observe(cbtn, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
    }
  }

  /* 7. single "View photos" gallery per ambient package — sits after the
     bullet list, tapping it drops a photo grid open inline (native
     <details>/<summary>, same pattern used elsewhere on the site).
     stopPropagation so opening it doesn't also select/deselect the whole
     package card underneath it. */
  document.querySelectorAll('.zgallery-toggle > summary').forEach(function (summary) {
    summary.addEventListener('click', function (e) { e.stopPropagation(); });
  });

  /* Starlight tier video preview toggle — same stopPropagation treatment
     so opening it doesn't select/deselect the Standard/Large tier card. */
  document.querySelectorAll('.star-preview-toggle > summary').forEach(function (summary) {
    summary.addEventListener('click', function (e) { e.stopPropagation(); });
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-header"]) return;
  try {
    
(function () {
  function paint(n) {
    document.querySelectorAll('.apex-shell [data-cart-count]').forEach(function (el) {
      el.textContent = n > 0 ? String(n) : '';
      el.classList.toggle('is-on', n > 0);
    });
  }
  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) paint(c.item_count || 0); })
      .catch(function () {});
  }
  refresh();
  document.addEventListener('cart:added', refresh);

  var path = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
  document.querySelectorAll('.apex-shell .apex-link').forEach(function (a) {
    var href = (a.getAttribute('href') || '').replace(/\/+$/, '') || '/';
    if (href === path) a.classList.add('is-active');
  });

  var burger = document.getElementById('apexBurger');
  var nav = document.getElementById('apexNav');
  if (burger && nav) {
    /* Mobile menu lives on <body> (same escape-hatch as the cart drawer):
       inline styles + body-level fixed positioning defeat every combination
       of backdrop-filter containing blocks, section stacking contexts and
       theme-editor iframes that swallowed the panel before. */
    var headerEl = document.querySelector('.apex-header');
    var mqm = window.matchMedia('(max-width: 900px)');
    var homeParent = nav.parentElement, homeNext = nav.nextElementSibling;

    function headerBottom() {
      try { return Math.max(44, Math.round(headerEl.getBoundingClientRect().bottom)); }
      catch (e) { return 60; }
    }
    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      burger.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (mqm.matches) {
        var hb = headerBottom();
        nav.style.top = hb + 'px';
        nav.style.maxHeight = 'calc(100vh - ' + hb + 'px)';
        nav.style.display = open ? 'flex' : 'none';
      }
    }
    function toMobile() {
      if (nav.parentElement !== document.body) document.body.appendChild(nav);
      nav.style.cssText = 'display:none;position:fixed;left:0;right:0;top:' + headerBottom() + 'px;' +
        'z-index:2147483000;background:#0a0a0e;flex-direction:column;padding:10px 20px 24px;' +
        'overflow-y:auto;max-height:calc(100vh - ' + headerBottom() + 'px);' +
        'border-bottom:1px solid rgba(255,255,255,0.12);box-shadow:0 30px 60px rgba(0,0,0,0.6);';
      setOpen(false);
    }
    function toDesktop() {
      if (nav.parentElement === document.body) {
        if (homeNext && homeNext.parentElement === homeParent) homeParent.insertBefore(nav, homeNext);
        else homeParent.appendChild(nav);
      }
      nav.removeAttribute('style');
      nav.classList.remove('is-open');
      burger.classList.remove('is-open');
    }
    function applyMode() { if (mqm.matches) toMobile(); else toDesktop(); }
    applyMode();
    if (mqm.addEventListener) mqm.addEventListener('change', applyMode);
    else if (mqm.addListener) mqm.addListener(applyMode);

    burger.addEventListener('click', function () {
      setOpen(!nav.classList.contains('is-open'));
    });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('apexLanding');
  if (!root || root.dataset.alInit) return;
  root.dataset.alInit = '1';

  /* ---- mood picker: re-tints every glow, and matches the product photo ---- */
  var moods = [
    { name: 'Ice',     a: [79,216,255],  b: [160,107,255], img: 'blue'   },
    { name: 'Violet',  a: [176,102,255], b: [255,102,204], img: 'purple' },
    { name: 'Magenta', a: [255,80,160],  b: [176,102,255], img: 'purple' },
    { name: 'Crimson', a: [255,70,70],   b: [255,140,60],  img: 'red'    },
    { name: 'Emerald', a: [80,255,160],  b: [79,216,255],  img: 'green'  },
    { name: 'Amber',   a: [255,190,80],  b: [255,110,60],  img: null     },
    { name: 'Pure',    a: [235,240,255], b: [150,170,220], img: null     }
  ];
  var swWrap = document.getElementById('alSwatches');

  function showProdImg(color) {
    if (!color) return;
    root.querySelectorAll('.al-prod-img').forEach(function (im) {
      im.classList.toggle('is-active', im.getAttribute('data-color') === color);
    });
    root.querySelectorAll('.al-psw').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-color') === color);
    });
  }

  if (swWrap) {
    moods.forEach(function (m, i) {
      var s = document.createElement('button');
      s.type = 'button';
      s.className = 'al-sw' + (i === 0 ? ' is-on' : '');
      s.title = m.name;
      s.setAttribute('aria-label', 'Colour mood: ' + m.name);
      s.style.background = 'linear-gradient(135deg, rgb(' + m.a.join(',') + ') 0%, rgb(' + m.b.join(',') + ') 100%)';
      s.addEventListener('click', function () {
        root.style.setProperty('--a-rgb', m.a.join(','));
        root.style.setProperty('--b-rgb', m.b.join(','));
        swWrap.querySelectorAll('.al-sw').forEach(function (x) { x.classList.remove('is-on'); });
        s.classList.add('is-on');
        showProdImg(m.img);
      });
      swWrap.appendChild(s);
    });
  }

  /* ---- product photo swatches ---- */
  root.querySelectorAll('.al-psw').forEach(function (b) {
    b.addEventListener('click', function () { showProdImg(b.getAttribute('data-color')); });
  });

  /* ---- add to cart ---- */
  var addBtn = document.getElementById('alAddBtn');
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var vid = addBtn.getAttribute('data-variant-id');
      if (!vid) { window.location.href = '/collections/all'; return; }
      addBtn.disabled = true;
      var orig = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        addBtn.textContent = 'Added ✓';
        addBtn.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('cart:added'));
        setTimeout(function () {
          addBtn.textContent = orig;
          addBtn.classList.remove('is-added');
          addBtn.disabled = false;
        }, 2200);
      }).catch(function () {
        addBtn.textContent = 'Try again';
        addBtn.disabled = false;
      });
    });
  }

  /* ---- fade-up on scroll ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    root.querySelectorAll('.al-fade').forEach(function (el) { io.observe(el); });
  } else {
    root.querySelectorAll('.al-fade').forEach(function (el) { el.classList.add('is-in'); });
  }

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll-progress light beam ---- */
  var beam = document.getElementById('alBeam');
  if (beam && !reduced) {
    var beamRaf = false;
    function paintBeam() {
      beamRaf = false;
      var doc = document.documentElement;
      var p = doc.scrollHeight > doc.clientHeight ? (window.scrollY / (doc.scrollHeight - doc.clientHeight)) : 0;
      beam.style.transform = 'scaleY(' + Math.min(1, Math.max(0, p)) + ')';
    }
    window.addEventListener('scroll', function () {
      if (!beamRaf) { beamRaf = true; requestAnimationFrame(paintBeam); }
    }, { passive: true });
    paintBeam();
  }

  /* ---- cursor-following ambient glow (lerped, rAF) ---- */
  var glow = document.getElementById('alGlowCur');
  if (glow && !reduced && window.matchMedia('(hover: hover)').matches) {
    var gx = -1000, gy = -1000, tx = gx, ty = gy, glowLive = false;
    document.addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      if (!glowLive) { glowLive = true; glow.classList.add('live'); }
    }, { passive: true });
    (function loop() {
      gx += (tx - gx) * 0.08; gy += (ty - gy) * 0.08;
      glow.style.transform = 'translate(' + gx.toFixed(1) + 'px,' + gy.toFixed(1) + 'px)';
      requestAnimationFrame(loop);
    })();
  }

  /* ---- stats count up on first view ---- */
  if (!reduced && 'IntersectionObserver' in window) {
    var statIo = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        statIo.unobserve(e.target);
        var node = e.target.firstChild; // leading text node, e.g. "5" / "4.9" / "16" / "1"
        if (!node || node.nodeType !== 3) return;
        var raw = node.textContent.trim();
        var target = parseFloat(raw);
        if (isNaN(target)) return;
        var dec = raw.indexOf('.') > -1 ? 1 : 0;
        var t0 = performance.now();
        (function tick(t) {
          var k = Math.min(1, (t - t0) / 1100);
          var eased = 1 - Math.pow(1 - k, 3);
          node.textContent = (target * eased).toFixed(dec);
          if (k < 1) requestAnimationFrame(tick);
          else node.textContent = raw;
        })(t0);
      });
    }, { threshold: 0.6 });
    root.querySelectorAll('.al-stat b').forEach(function (b) { statIo.observe(b); });
  }

  /* ---- kit card 3D tilt ---- */
  if (!reduced && window.matchMedia('(hover: hover)').matches) {
    root.querySelectorAll('.al-kit').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(900px) rotateX(' + (-py * 4).toFixed(2) + 'deg) rotateY(' + (px * 4).toFixed(2) + 'deg) translateZ(0)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  /* ---- drop broken videos so posters/gradients show ---- */
  root.querySelectorAll('video').forEach(function (v) {
    v.addEventListener('error', function () { v.removeAttribute('autoplay'); v.style.display = 'none'; }, true);
    var src = v.querySelector('source');
    if (src) src.addEventListener('error', function () { v.style.display = 'none'; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-password"]) return;
  try {
    
(function () {
  // Countdown
  const wrap = document.getElementById('apxCountdown');
  if (wrap) {
    let target = wrap.getAttribute('data-target');
    if (!target) {
      // default: 7 days from page load
      const t = new Date();
      t.setDate(t.getDate() + 7);
      target = t.toISOString();
    }
    const t = new Date(target).getTime();
    const dEl = wrap.querySelector('[data-d]');
    const hEl = wrap.querySelector('[data-h]');
    const mEl = wrap.querySelector('[data-m]');
    const sEl = wrap.querySelector('[data-s]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      const now = Date.now();
      let diff = Math.max(0, t - now);
      const d = Math.floor(diff / (1000*60*60*24)); diff -= d * 86400000;
      const h = Math.floor(diff / (1000*60*60));    diff -= h * 3600000;
      const m = Math.floor(diff / (1000*60));       diff -= m * 60000;
      const s = Math.floor(diff / 1000);
      if (dEl) dEl.textContent = pad(d);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  // Password toggle
  const tog = document.getElementById('apxPwdToggle');
  const box = document.getElementById('apxPwdBox');
  if (tog && box) {
    tog.addEventListener('click', function (e) {
      e.preventDefault();
      const open = box.hasAttribute('hidden');
      if (open) box.removeAttribute('hidden'); else box.setAttribute('hidden', '');
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-product-elite"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('apexPel');
  if (!root || root.dataset.pelInit) return;
  root.dataset.pelInit = '1';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- colour rail: re-tints page + swaps real photos ---- */
  var moods = [
    { name: 'Violet',  a: [176,102,255], b: [255,102,204], img: 'purple' },
    { name: 'Ice',     a: [79,216,255],  b: [160,107,255], img: 'blue'   },
    { name: 'Magenta', a: [255,80,160],  b: [176,102,255], img: 'purple' },
    { name: 'Crimson', a: [255,70,70],   b: [255,140,60],  img: 'red'    },
    { name: 'Emerald', a: [80,255,160],  b: [79,216,255],  img: 'green'  },
    { name: 'Amber',   a: [255,190,80],  b: [255,110,60],  img: 'red'    },
    { name: 'Pure',    a: [235,240,255], b: [150,170,220], img: 'blue'   }
  ];
  function showImg(c) {
    root.querySelectorAll('.pel-gal-main img').forEach(function (im) { im.classList.toggle('on', im.getAttribute('data-c') === c); });
    root.querySelectorAll('.pel-thumb').forEach(function (t) { t.classList.toggle('on', t.getAttribute('data-c') === c); });
  }
  var swWrap = document.getElementById('pelSwatches');
  if (swWrap) {
    moods.forEach(function (m, i) {
      var s = document.createElement('button');
      s.type = 'button';
      s.className = 'pel-sw' + (i === 0 ? ' on' : '');
      s.title = m.name;
      s.setAttribute('aria-label', 'Colour: ' + m.name);
      s.style.background = 'linear-gradient(135deg, rgb(' + m.a.join(',') + '), rgb(' + m.b.join(',') + '))';
      s.addEventListener('click', function () {
        root.style.setProperty('--a-rgb', m.a.join(','));
        root.style.setProperty('--b-rgb', m.b.join(','));
        swWrap.querySelectorAll('.pel-sw').forEach(function (x) { x.classList.remove('on'); });
        s.classList.add('on');
        var nm = document.getElementById('pelMoodName');
        if (nm) nm.textContent = m.name;
        showImg(m.img);
      });
      swWrap.appendChild(s);
    });
  }
  root.querySelectorAll('.pel-thumb').forEach(function (t) {
    t.addEventListener('click', function () { showImg(t.getAttribute('data-c')); });
  });

  /* ---- variant pills ---- */
  var addBtn = document.getElementById('pelAdd');
  root.querySelectorAll('.pel-vpill').forEach(function (p) {
    p.addEventListener('click', function () {
      if (p.disabled) return;
      root.querySelectorAll('.pel-vpill').forEach(function (x) { x.classList.remove('on'); });
      p.classList.add('on');
      addBtn.setAttribute('data-vid', p.getAttribute('data-vid'));
      root.querySelector('.pel-price').textContent = p.getAttribute('data-price');
      var bb = document.getElementById('pelBbPrice');
      if (bb) bb.textContent = p.getAttribute('data-price');
    });
  });

  /* ---- qty ---- */
  var qtyEl = document.getElementById('pelQty');
  root.querySelectorAll('.pel-qty button').forEach(function (b) {
    b.addEventListener('click', function () {
      qtyEl.textContent = Math.max(1, parseInt(qtyEl.textContent, 10) + parseInt(b.getAttribute('data-d'), 10));
    });
  });

  /* ---- add to cart (real) ---- */
  function addToCart(btn) {
    var vid = addBtn.getAttribute('data-vid');
    if (!vid || btn.disabled) return;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: parseInt(qtyEl.textContent, 10) || 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      btn.textContent = 'Added ✓';
      btn.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('cart:added'));
      setTimeout(function () {
        btn.textContent = orig;
        btn.classList.remove('is-added');
        btn.disabled = false;
      }, 2200);
    }).catch(function () {
      btn.textContent = 'Try again';
      btn.disabled = false;
    });
  }
  if (addBtn) addBtn.addEventListener('click', function () { addToCart(addBtn); });
  var bbAdd = document.getElementById('pelBbAdd');
  if (bbAdd) bbAdd.addEventListener('click', function () { addToCart(bbAdd); });

  /* ---- floating buy bar after hero ---- */
  var bar = document.getElementById('pelBuybar');
  var hero = root.querySelector('.pel-hero');
  if (bar && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { bar.classList.toggle('show', !e.isIntersecting); });
    }, { threshold: 0.08 }).observe(hero);
  }

  /* ---- cursor glow ---- */
  var glow = document.getElementById('pelGlowCur');
  if (glow && !reduced && window.matchMedia('(hover: hover)').matches) {
    var gx = -1000, gy = -1000, tx = gx, ty = gy, live = false;
    document.addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      if (!live) { live = true; glow.classList.add('live'); }
    }, { passive: true });
    (function loop() {
      gx += (tx - gx) * 0.08; gy += (ty - gy) * 0.08;
      glow.style.transform = 'translate(' + gx.toFixed(1) + 'px,' + gy.toFixed(1) + 'px)';
      requestAnimationFrame(loop);
    })();
  }

  /* ---- fades ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    root.querySelectorAll('.pel-fade').forEach(function (el) { io.observe(el); });
  } else {
    root.querySelectorAll('.pel-fade').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---- drop broken videos ---- */
  root.querySelectorAll('video').forEach(function (v) {
    v.addEventListener('error', function () { v.style.display = 'none'; }, true);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-starlight-elite"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('apexSel');
  if (!root || root.dataset.selInit) return;
  root.dataset.selInit = '1';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- starfield ---- */
  var field = document.getElementById('selField');
  function buildField(n) {
    field.innerHTML = '';
    var frag = document.createDocumentFragment();
    for (var i = 0; i < n; i++) {
      var s = document.createElement('div');
      s.className = 'sel-st';
      var sz = Math.random() < 0.85 ? (Math.random() * 1.4 + 0.6) : (Math.random() * 2 + 1.6);
      s.style.width = s.style.height = sz.toFixed(1) + 'px';
      s.style.left = (Math.random() * 100) + '%';
      s.style.top = (Math.random() * 100) + '%';
      s.style.setProperty('--o', (Math.random() * 0.55 + 0.3).toFixed(2));
      s.style.animationDuration = (Math.random() * 4 + 2.5).toFixed(1) + 's';
      s.style.animationDelay = (-Math.random() * 6).toFixed(1) + 's';
      frag.appendChild(s);
    }
    field.appendChild(frag);
  }
  var baseDensity = Math.min(220, Math.floor(window.innerWidth / 7));
  if (!reduced) buildField(baseDensity);

  /* ---- shooting star ---- */
  var meteor = document.getElementById('selMeteor');
  function shoot() {
    meteor.style.left = (55 + Math.random() * 40) + 'vw';
    meteor.style.top = (Math.random() * 30) + 'vh';
    meteor.style.animation = 'none'; void meteor.offsetWidth;
    meteor.style.animation = 'selShoot 5s linear';
    setTimeout(shoot, 5000 + Math.random() * 6000);
  }
  if (!reduced && meteor) setTimeout(shoot, 1800);

  /* ---- star counter ---- */
  var countEl = document.getElementById('selStarCount');
  function countTo(n) {
    var from = parseInt(countEl.textContent.replace(/,/g, ''), 10) || 0, t0 = performance.now();
    (function f(t) {
      var k = Math.min(1, (t - t0) / 1400), e = 1 - Math.pow(1 - k, 3);
      countEl.textContent = Math.round(from + (n - from) * e).toLocaleString('en-GB');
      if (k < 1) requestAnimationFrame(f);
    })(t0);
  }

  /* ---- variant cards ---- */
  var addBtn = document.getElementById('selAdd');
  var cards = root.querySelectorAll('.sel-vc');
  var firstStars = cards.length ? parseInt(cards[0].getAttribute('data-stars'), 10) || 600 : 600;
  function selectCard(c) {
    if (c.hasAttribute('data-soldout')) return;
    cards.forEach(function (x) { x.classList.remove('on'); });
    c.classList.add('on');
    var price = c.getAttribute('data-price');
    var n = parseInt(c.getAttribute('data-stars'), 10) || 600;
    addBtn.setAttribute('data-vid', c.getAttribute('data-vid'));
    document.getElementById('selPrice').textContent = price;
    document.getElementById('selBbPrice').textContent = price;
    document.getElementById('selBbVariant').textContent = n.toLocaleString('en-GB') + ' stars';
    countTo(n);
    if (!reduced) buildField(Math.floor(baseDensity * (n > firstStars ? 1.8 : 1)));
  }
  cards.forEach(function (c) { c.addEventListener('click', function () { selectCard(c); }); });
  countTo(firstStars);

  /* ---- qty ---- */
  var qtyEl = document.getElementById('selQty');
  root.querySelectorAll('.sel-qty button').forEach(function (b) {
    b.addEventListener('click', function () {
      qtyEl.textContent = Math.max(1, parseInt(qtyEl.textContent, 10) + parseInt(b.getAttribute('data-d'), 10));
    });
  });

  /* ---- add to cart (real) ---- */
  function addToCart(btn) {
    var vid = addBtn.getAttribute('data-vid');
    if (!vid || btn.disabled) return;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: parseInt(qtyEl.textContent, 10) || 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      btn.textContent = 'Added ✓';
      btn.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('cart:added'));
      setTimeout(function () {
        btn.textContent = orig;
        btn.classList.remove('is-added');
        btn.disabled = false;
      }, 2200);
    }).catch(function () {
      btn.textContent = 'Try again';
      btn.disabled = false;
    });
  }
  if (addBtn) addBtn.addEventListener('click', function () { addToCart(addBtn); });
  var bbAdd = document.getElementById('selBbAdd');
  if (bbAdd) bbAdd.addEventListener('click', function () { addToCart(bbAdd); });

  /* ---- buy bar after hero ---- */
  var bar = document.getElementById('selBuybar');
  var hero = root.querySelector('.sel-hero');
  if (bar && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { bar.classList.toggle('show', !e.isIntersecting); });
    }, { threshold: 0.05 }).observe(hero);
  }

  /* ---- fades ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    root.querySelectorAll('.sel-fade').forEach(function (el) { io.observe(el); });
  } else {
    root.querySelectorAll('.sel-fade').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---- drop broken videos ---- */
  root.querySelectorAll('video').forEach(function (v) {
    v.addEventListener('error', function () { v.style.display = 'none'; }, true);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
